import { useEffect, useState, useRef, useMemo, use } from 'react';
import Header from '../components/header';
import './relatorio.css'
import { useLocation } from 'react-router-dom';
import Icon from '@mdi/react';
import Gratuito from './grauito';
import { GoogleMap, Marker, StreetViewPanorama } from "@react-google-maps/api";
import LoadingRelatorio from '../components/loading_relatorio';
import Indicadores from './indicadores';
import RelatorioPago from './relatorio_pago';
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { mdiBus, mdiHomeFlood, mdiMapMarkerRadius, mdiNewspaperVariantMultipleOutline, mdiOfficeBuilding, mdiSecurity } from '@mdi/js';
import Footer from '../components/footer';
import { API_BASE_URL } from '../../global';
import { registrarLog } from "../../global";
import Popup from '../components/popup';

const GOOGLE_API = 'AIzaSyCRJnBSTStmvD5-WUr03HCQNHJ44N4Nz5g';

export default function Relatorio({ isAuth, setIsAuth }) {

  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [resultado, setResultado] = useState(location.state?.resultado)

  const [loadBar, setLoadBar] = useState(0);

  const [popup, setPopup] = useState(false);
  const [popupTitulo, setPopupTitulo] = useState('');
  const [popupMensagem, setPopupMensagem] = useState('');
  const [popupOpcoes, setPopupOpcoes] = useState('ok');
  const [popupIcone, setPopupIcone] = useState('erro');

  //INDICADORES / NOTAS
  const [indSeguranca, setIndSeguranca] = useState(0);
  const [indSegurancaNota, setIndSegurancaNota] = useState(0);
  const [indInfra, setIndInfra] = useState(0);
  const [indTransporte, setIndTransporte] = useState(0);
  const [indClima, setIndClima] = useState(0);

  const [indSegurancaTexto, setIndSegurancaTexto] = useState('');
  const [indInfraTexto, setIndInfraTexto] = useState('');
  const [indTransporteTexto, setIndTransporteTexto] = useState('');
  const [indClimaTexto, setIndClimaTexto] = useState('');

  //VERIFICAÇÃO DE AUTENTICAÇÃO
  useEffect(() => {
    const verified = localStorage.getItem("verificado");
    const auth = localStorage.getItem("auth");
    if (verified === "false") {
      navigate('/EmailVerify')
    }
  }, []);

  //CAPTURA O CENTRO DE LATITUDE E LONGITUDE - POSIÇÃO DO STREET VIEW
  const center = resultado
    ? {
      lat: resultado.geometry.location.lat,
      lng: resultado.geometry.location.lng
    }
    : null;



  function getComponent(components, type) {
    const item = components.find(c => c.types.includes(type));
    return item?.long_name || null;
  }

  const endereco = useMemo(() => {
    if (!resultado) return

    const components = resultado.address_components;
    return {
      rua: getComponent(components, "route"),
      bairro:
        getComponent(components, "sublocality") ||
        getComponent(components, "political"),
      cidade: getComponent(components, "administrative_area_level_2"),
      estado: getComponent(components, "administrative_area_level_1"),
      cep: getComponent(components, "postal_code"),
      latitude: resultado.geometry.location.lat,
      longitude: resultado.geometry.location.lng,
      numero: getComponent(components, "street_number")
    };
  }, [resultado]);

  const [gratuito, setGratuito] = useState(true);
  const [loading, setLoading] = useState(false)
  const mapRef = useRef(null);
  const streetRef = useRef(null);
  const streetInitialized = useRef(false);
  const [mapReady, setMapReady] = useState(false);

  const [cep, setCep] = useState(searchParams.get("cep") ?? 'CEP não encontrado');
  const [descritivoNoticias, setDescritivosNoticias] = useState('');

  const [dataRelatorio, setDataRelatorio] = useState({
    pontos_onibus: { total: 0, pontos: [] },
    estacoes_metro: { total: 0, estacoes: [] },
    terminais_onibus: { total: 0, terminais: [] },
    estacoes_trem: { total: 0, estacoes: [] },
    ocorrencias_geo_hidro: { alagamentos: { total: 0, ocorrencias: [] }, inundacoes: { ocorrencias: [], total: 0 }, deslizamentos: { ocorrencias: [], total: 0 }, queda_arvore: { ocorrencias: [], total: 0 } },
    seguranca_publica: { ocorrencias_default: { ocorrencias: [], ocorrencias_total: 0 }, ocorrencias_12_meses: { ocorrencias: [], ocorrencias_total: 0 }, media_12_meses: 0, tipo_ocorrencias: { ocorrencias: [], ocorrencias_distintas: 0 }, bairro: { ocorrencias: [], ocorrencias_total: 0, ocorrencias_12_meses: { ocorrencias: [], ocorrencias_total: 0 }, media_12_meses: 0, tipo_ocorrencias: { ocorrencias: [], ocorrencias_distintas: 0 } } },
    restaurantes: [],
    supermercados: [],
    farmacias: [],
    hospitais: [],
    climaTempo: []
  });

  const [dadosIndicadores, setDadosIndicadores] = useState({
    pontos_onibus: 0,
    terminais_onibus: 0,
    estacoes_metro: 0,
    seguranca_publica: 0,
    restaurantes: 0,
    supermercados: 0,
    farmacias: 0,
    hospitais: 0,
    desastres_ambientais: 0,
    climaTempo: 0
  })

  //DADOS INDICADORES
  const baseIndicadores = async (end) => {
    try {
      const response = await fetch(`${API_BASE_URL}/relatorio/calculo-indicadores.php`, {
        method: 'POST',
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          rua: end.rua,
          bairro: end.bairro,
          cep: end.cep || cep,
          estado: end.estado,
          cidade: end.cidade,
          lat: end.latitude,
          lng: end.longitude
        })
      })

      const data = await response.json();
      if (data) {
        setDadosIndicadores(data)
        setLoadBar(60)
      } else {
        console.log("Erro durante coleta de dados de indicadores")
      }
    } catch (error) {
      console.log(error);
    }
  }

  //PUXAR DADOS DO RELATÓRIO PREMIUM
  const relatorioPremium = async (end) => {
    try {
      const response = await fetch(`${API_BASE_URL}/relatorio/get_dados_relatorio.php`, {
        method: 'POST',
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          rua: end.rua,
          bairro: end.bairro,
          cep: end.cep || cep,
          estado: end.estado,
          cidade: end.cidade,
          lat: end.latitude,
          lng: end.longitude
        })
      })

      const data = await response.json();
      setDataRelatorio(data);
      setLoadBar(100);

      registrarLog('Relatório', 'Visualizou relatório Premium', end.cep || cep);
    } catch (error) {
      console.error(error)
    }
  }

  const crawlerNoticias = async (bairroPesquisa) => {
    if (!bairroPesquisa) return;
    try {
      const response = await fetch(`${API_BASE_URL}/crawlers/crawler-noticia.php`, {
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          bairro: bairroPesquisa,
        })
      })
      const data = await response.text();
      setDescritivosNoticias(data)
    } catch (error) {
      console.log('Erro ao obter resumo de notícias: ' + error);
    }
  }

  // FUNÇÃO CENTRALIZADA PARA CARREGAR OS DADOS DO RELATÓRIO
  const carregarDadosRelatorio = async (end) => {
    setLoading(true);
    setLoadBar(20);
    try {
      const response = await fetch(`${API_BASE_URL}/relatorio/verificar_aquisicao.php`, {
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ cep: end.cep || cep })
      });
      const data = await response.json();

      await baseIndicadores(end);

      if (data.status === 'success' && data.msg === 'Relatório adquirido') {
        setGratuito(false);
        setLoadBar(40);
        await relatorioPremium(end);
      } else {
        setGratuito(true);
        registrarLog('Relatório', 'Visualizou relatório gratuito', end.cep || cep);
      }

      await crawlerNoticias(end.bairro);

    } catch (error) {
      console.log("Erro no carregamento de dados:", error);
    } finally {
      setLoading(false);
    }
  };

  const placeId = searchParams.get("id");
  const urlCep = searchParams.get("cep");

  // BUSCA ENDEREÇO VIA ID OU CEP SE RESULTADO ESTIVER VAZIO
  useEffect(() => {
    if (!resultado && (placeId || urlCep)) {
      const fetchResultado = async () => {
        try {
          const url = placeId 
            ? `https://maps.googleapis.com/maps/api/geocode/json?place_id=${placeId}&key=${GOOGLE_API}`
            : `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(urlCep)}&components=country:BR&key=${GOOGLE_API}`;
          
          const response = await fetch(url);
          const data = await response.json();
          if (data.status === "OK") {
            setResultado(data.results[0]);
          } else {
            navigate('/');
          }
        } catch (error) {
          console.error("Erro ao buscar endereço alternativo:", error);
          navigate('/');
        }
      }
      fetchResultado();
    } else if (!resultado && !placeId && !urlCep) {
      navigate('/');
    }
  }, [placeId, urlCep, resultado, navigate]);

  // ORQUESTRA O CARREGAMENTO QUANDO TEMOS O ENDEREÇO
  useEffect(() => {
    if (endereco && resultado) {
      if (endereco.cep && endereco.cep !== cep) {
        setCep(endereco.cep);
      }
      carregarDadosRelatorio(endereco);
    }
  }, [endereco, resultado]);

  //MAPA DO STREET VIEW
  useEffect(() => {
    if (!center || !mapReady || !streetRef.current || streetInitialized.current) return;

    streetInitialized.current = true;

    const panorama = new window.google.maps.StreetViewPanorama(
      streetRef.current,
      {
        position: center,
        pov: { heading: 100, pitch: 0 },
        zoom: 1
      }
    );

    mapRef.current.setStreetView(panorama);

  }, [mapReady, center]);


  const desbloquearRelatorio = async () => {
    registrarLog('Relatório', 'Clicou em desbloquear relatório', null);
    if (!isAuth) return navigate('/Autenticacao')

    setLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}/relatorio/desbloquear-relatorio.php`, {
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          cep: endereco.cep || cep,
          rua: endereco.rua,
          numero: endereco.numero,
          latitude: endereco.latitude,
          longitude: endereco.longitude,
          bairro: endereco.bairro,
          cidade: endereco.cidade
        })
      })
      const data = await response.json();
      if (data.status === 'success') {
        if (data.msg === 'Relatório adquirido com sucesso') {
          registrarLog('Relatório', 'Adquiriu relatório', null);
          window.dispatchEvent(new Event('atualizarCreditos'));
          setGratuito(false);
          await relatorioPremium(endereco);
          setLoading(false);
        } else {
          setPopup(true);
          setPopupTitulo('Falha na aquisição');
          setPopupIcone('cancel');
          setPopupMensagem('Ocorreu um erro ao desbloquear o relatório. Entre em contato com o suporte.');
          setLoading(false);
        }
      } else {
        setPopup(true);
        setPopupTitulo('Créditos insuficientes');
        setPopupIcone('cancel');
        setPopupMensagem('Você não possui créditos suficientes para desbloquear este relatório.');
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  }


  function handleMapLoad(map) {
    mapRef.current = map;
    setMapReady(true);
  }

  if (!resultado || !endereco) {
    return <LoadingRelatorio />;
  }

  const zoom = 18;
  const { rua, bairro, cidade, estado, numero, latitude, longitude } = endereco;




  return (
    <div className="relatorio_body">

      {loading && (<LoadingRelatorio loadBar={loadBar} setLoadBar={setLoadBar}></LoadingRelatorio>)}

      <Header isAuth={isAuth} setIsAuth={setIsAuth} />

      <div className='relatorio_container' id='relatorio_completo' >
        <div className='relatorio_titulo'>
          <h1>Relatório de Ocorrências e Riscos</h1>
          <h2>{rua}</h2>
          <p>{(!bairro || String(bairro).toLowerCase() === 'undefined' || bairro === cidade) ? 'Bairro não identificado' : bairro}, {cidade}, {estado}</p>
          <p>{(!cep || String(cep).toLowerCase() === 'undefined') ? 'CEP não identificado' : cep}</p>
        </div>

        <Indicadores dadosIndicadores={dadosIndicadores} cidade={cidade}></Indicadores>

        <div className='block-sw_resumo'>

          <div className='block-sw_resumo_streetview'>
            <div className="map-wrapper">

              <GoogleMap
                onLoad={handleMapLoad}
                mapContainerStyle={{ width: "100%", height: "100%" }}
                center={center}
                zoom={zoom}
                options={{
                  mapTypeId: "hybrid",
                  draggable: false,
                  zoomControl: false,
                  scrollwheel: false,
                  disableDoubleClickZoom: true,
                  gestureHandling: "none",
                  streetViewControl: false,
                }}
              />

              {/*<div
                ref={streetRef}
                className='street-view'

              />*/}

            </div>
          </div>
          <div className='block-sw_resumo_resumo'>
            <div className='block-sw_resumo_resumo_content'>
              <h2><Icon path={mdiNewspaperVariantMultipleOutline} size={1} />Destaques da região</h2>
              <p>{descritivoNoticias}</p>
              <p className='info-fonte'>Fonte: Notícias Google</p>
            </div>

          </div>

        </div>


        <p className='micro-legenda' style={{ marginTop: 0, marginBottom: 20, width: '100%', backgroundColor: '#FF6F3311', borderColor: '#FF6F3355', color: '#666' }}><Icon path={mdiMapMarkerRadius} size={1} style={{ verticalAlign: '-3px' }} /> Visualização geográfica do endereço analisado e seu entorno imediato, com base em dados oficiais de localização.</p>

        {gratuito && <Gratuito desbloquearRelatorio={desbloquearRelatorio} dadosIndicadores={dadosIndicadores}></Gratuito>}

        {!gratuito && <RelatorioPago dataRelatorio={dataRelatorio} googleAPI={GOOGLE_API} rua={rua} latitude={latitude} longitude={longitude} cidade={cidade}></RelatorioPago>}

      </div>

      <Popup titulo={popupTitulo} mensagem={popupMensagem} opcoes={popupOpcoes} icone={popupIcone} setPopup={setPopup} popup={popup}></Popup>
      <Footer></Footer>
    </div>
  );
}
